<template>
  <v-icon :disabled="disabled" :class="className" :icon="iconName" :size="size" :color="color" />
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';

const props = defineProps({
  icon: { type: String, default: '' },
  color: { type: String, default: '' },
  size: { type: [Number, String], default: '' },
  variant: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});

const className = computed(() => {
  switch (props.variant) {
    case 'outlined':
      return 'material-icons-outlined';
    case 'rounded':
      return 'material-icons-rounded';
    case 'sharp':
      return 'material-icons-sharp';
    case 'twotone':
      return 'material-icons-two-tone';
    default:
      return '';
  }
});

const iconName = computed(() => {
  return `md:${props.icon}`;
});
</script>
